import moment from 'moment';
import { BookitupScope, ProfileShare } from '../../../Service/ProfileS';

const dateFormatter = new Intl.DateTimeFormat('de-DE', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
});

export const formatDateTime = (value?: string | null) => {
  if (!value) {
    return '-';
  }

  const date = new Date(value);

  if (Number.isNaN(date.getTime())) {
    return value;
  }

  return dateFormatter.format(date);
};

export const formatRelativeDateTime = (value?: string | null) => {
  if (!value) {
    return '-';
  }

  const date = moment(value);

  if (!date.isValid()) {
    return value;
  }

  return date.locale('de').fromNow();
};

export const getTextValue = (value?: string | null) => value || '-';

const parseMailAccountId = (account: number | string | null | undefined) => {
  if (account === null || account === undefined || (typeof account === 'string' && account.trim() === '')) {
    return null;
  }

  const mailAccountId = Number(account);
  return Number.isFinite(mailAccountId) ? mailAccountId : null;
};

export const normalizeMailAccounts = (accounts?: Array<number | string | null | undefined> | null) =>
  (accounts || [])
    .map(parseMailAccountId)
    .filter((account): account is number => account !== null)
    .filter(
      (account, index, normalizedAccounts) => Number.isFinite(account) && normalizedAccounts.indexOf(account) === index,
    );

export const areMailAccountsEqual = (left: number[], right: number[]) => left.join('|') === right.join('|');

export const areScopesEqual = (left: BookitupScope[], right: BookitupScope[]) => {
  if (left.length !== right.length) {
    return false;
  }

  return left.every((scope) => right.includes(scope));
};

export const getDisplayName = ({ firstName, lastName, email }: ProfileShare) => {
  const displayName = [firstName, lastName].filter(Boolean).join(' ').trim();
  return displayName || email;
};
